
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import apiService from '~/services/api.service';

@Component
export default class UsersSelector extends Vue {
    @Prop({ default: () => [] }) userList!: { id: string, reference: string }[];
    @Prop({ default: false }) isDisabled!: boolean;

    input = '';
    searchQuery = '';
    userEmails: { [k: string]: { id: string, mail: string }; } = {};

    @Watch('userList', { immediate: true, deep: true })
    async onUserListChange() {
        this.userEmails = Object.fromEntries(this.userList.map(userObject => {
            return [userObject.reference, { id: userObject.reference, mail: '' }];
        }));
        const usersInfoResponse = await apiService.getusersinfo({ user_ids: this.userList.map((u: any) => u.reference) });
        this.userList.forEach(async user => {
            if (this.userEmails[user.reference].mail) {
                return;
            }
            this.userEmails[user.reference].mail = usersInfoResponse.data.body.users.find((u: any) => u.id === user.reference)?.email || '';

        });
    }
    get filteredUserEmails(): { [k: string]: { id: string, mail: string }; } {
        if (!this.searchQuery) {
            return this.userEmails;
        }
        const query = this.searchQuery.toLowerCase();
        return Object.fromEntries(
            Object.entries(this.userEmails)
                .filter(([key, user]) => {
                    return user.mail.toLowerCase().includes(query);
                })
        );
    }
    addUsers() {
        const usersToAdd = this.input.split(',').map(email => email.trim()).filter(email => email.length > 0);
        usersToAdd.forEach(email => {
            if (!this.userList.some(u => u.reference === email)) {
                this.$emit('addUser', email);
            }
        });
        this.input = '';
    }

    removeUser(user_id: string) {
        this.$emit('removeUser', user_id);
    }
}
